import { PayloadAction } from '@reduxjs/toolkit';

import { SingleOptions, VariantsState } from '../types';

/**
 * Reverts the selected options to a previous state.
 * Used when lazy variant loading fails - reverts to the previous
 * selection and shows an error message.
 */
const revertSelectionReducer = (state: VariantsState, action: PayloadAction<SingleOptions>) => {
  state.selectedSingleOptions = action.payload;
};

export default revertSelectionReducer;

